// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1B89z","header":"ClearentDisclaimer_header__JEfHF","inner":"ClearentDisclaimer_inner__18Q2h"};